import { put, call, takeEvery } from 'redux-saga/effects';
import * as apis from '../../network/apis/customers';
import * as types from './types';
import * as actions from './actions';
import { showErrorMsg, showSuccessMsg } from '../../utils/Helpers';

function* getCustomerSaga({ payload }) {
  try {
    const response = yield call(apis.getCustomerDetails, payload);
    yield put(actions.getCustomerDetailsResponse(response?.data?.customer));
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* getCustomersListSaga({ payload }) {
  try {
    const response = yield call(apis.getCustomersList, payload);
    yield put(
      actions.getCustomersResponse({
        list: response.data.customers,
        meta: {
          currentPage: +response.headers['current-page'],
          count: +response.headers['total-count'],
          pages: +response.headers['total-pages'],
        },
      })
    );
    if (+response.headers['current-page'] > +response.headers['total-pages']) {
      yield put(
        actions.getCustomersRequest({
          ...payload,
          page: +response.headers['total-pages'],
        })
      );
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}


function* blockOrUnblockCustomerSaga({payload}) {
  try {
    const response = yield call(apis.blockOrUnblockCustomer, payload);
    if(payload.data.status === "blocked"){
      yield showSuccessMsg('blockedSuccessfully');
    }else if (payload.data.status === "unblocked"){
      yield showSuccessMsg('unblockedSuccessfully');
    }
    yield put(actions.getRequestStatus(response?.data?.success));
  } catch (error) {
    yield put(actions.getRequestStatus(error.response?.data?.success));
    yield showErrorMsg(error.response?.data?.message);
  }
};

export default function* CustomersSagas() {
  yield takeEvery(types.GET_CUSTOMER_DETAILS_REQUEST, getCustomerSaga);
  yield takeEvery(types.GET_CUSTOMERS_REQUEST, getCustomersListSaga);
  yield takeEvery(types.BLOCK_OR_UNBLOCK_CUSTOMER, blockOrUnblockCustomerSaga);
}
